import React from "react";
import { DateTime } from "luxon";

const UserFormFields = ({
  user,
  disabled,
  nodate,
  onChange,
  nocustomer,
  location
}) => (
  <React.Fragment>
    <div className="form-group">
      <label className="control-label" htmlFor="company">
        Firmanavn
      </label>
      <input
        onChange={e => onChange(["user", "company"], e.target.value)}
        id="company"
        name="company"
        type="text"
        value={user.company}
        //placeholder={user.company}
        className="form-control input-md"
        disabled={disabled}
      />
    </div>

    {!location && (
      <div className="form-group">
        <label className="control-label" htmlFor="location">
          Lokasjon
        </label>
        <input
          onChange={e => onChange(["user", "location"], e.target.value)}
          id="location"
          name="location"
          type="text"
          placeholder={user.location.name}
          className="form-control input-md"
          disabled={disabled}
        />
      </div>
    )}

    {location && (
      <div className="form-group">
        <label className="control-label" htmlFor="location">
          Lokasjon
        </label>
        <div className="input-group mb-2">
          <select
            onChange={e => onChange(["user", "location_id"], e.target.value)}
            id="location"
            name="location"
            value={user.location_id}
            className="form-control"
            required
          >
            <option value="">Velg</option>
            {location.map(item => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    )}

    {!nodate && (
      <div className="form-group">
        <label className="control-label" htmlFor="date">
          Dato
        </label>
        <input
          id="date"
          name="date"
          type="text"
          placeholder={DateTime.local().toISODate()}
          className="form-control input-md"
          disabled={disabled}
        />
      </div>
    )}

    {!nocustomer && (
      <div className="form-group">
        <label className="control-label" htmlFor="orderer">
          Bestillers navn
        </label>
        <input
          onChange={e => onChange(["user", "orderer"], e.target.value)}
          id="orderer"
          name="orderer"
          type="text"
          placeholder="Bestiller Bestillesen"
          className="form-control input-md"
          required
        />
      </div>
    )}
  </React.Fragment>
);

export default UserFormFields;



// WEBPACK FOOTER //
// ./src/components/UserFormFields.js